import { range } from "lodash";
import { SVD, Matrix } from "ml-matrix";

//TODO: check if the same function is available in math.js
export const mod = (a, b) => {
  // cyclic modulo that works for negative numbers as well
  const c = a % b;
  return c < 0 ? c + b : c;
};

export function cyclicRangeInclusive({ N, boundaries }) {
  const [b0, b1] = boundaries;
  if (b0 >= N || b1 >= N) {
    throw new Error(`both boundaries must be less than the cycle length ${N}`);
  }
  if (b0 === b1) {
    return [b0];
  }
  if (b0 < b1) {
    return range(b0, b1 + 1);
  } else {
    return [...range(b0, N), ...range(0, b1 + 1)];
  }
}

export const shortestCyclicDistance = (x, y, N) =>
  Math.min(mod(y - x, N), mod(x - y, N));

export const truncatedSVDLeastSquares = ({ A, b }) => {
  let a = new Matrix(A);
  let bv = new Matrix([b]);
  bv = bv.transpose();
  const svdResult = new SVD(a);
  // Extract singular values, U matrix, and V matrix
  let { diagonal: q, U, V } = svdResult;

  // how many singular values to keep
  const minSingularValueCountToKeep = 6;
  let indexOfTooSmallSingularValue = q.findIndex((x) => x < 0.05 * q[0]);
  if (indexOfTooSmallSingularValue === -1) {
    indexOfTooSmallSingularValue = q.length;
  }
  let k = Math.max(indexOfTooSmallSingularValue, minSingularValueCountToKeep);

  // truncate SVD to keep k singular values
  U = U.subMatrixColumn(range(k));
  V = V.subMatrixColumn(range(k));
  q = q.slice(0, k);
  let invSigma = Matrix.diag(q.map((x) => 1 / x));

  // return LS solution
  return V.mmul(invSigma).mmul(U.transpose()).mmul(bv).to1DArray();
};

export const homogeneous2descartes = (homo) => {
  // return [homo[0][0] / homo[2][0], homo[1][0] / homo[2][0]];
  const [uw, vw, w] = homo;
  const elementWiseDivivdeByW = (arr) => arr.map((x, i) => x / w[i]);
  const u = elementWiseDivivdeByW(uw);
  const v = elementWiseDivivdeByW(vw);
  return [u, v];
};

export const getCyclicIndex = (arr, index) => {
  const length = arr.length;
  return index >= 0 ? index % length : ((index % length) + length) % length;
};
